import Button, { ButtonProps } from 'antd/es/button'
import { useAppSelector } from '../../redux/hooks'
import { selectThemeStyle } from '../../features/setting/setting.slice'

type IdeyaButtonProps = ButtonProps & {
  ideyaType?: 'secondary' | 'antd' | ''
}

export const IdeyaButton: React.FC<IdeyaButtonProps> = ({
  ideyaType,
  style,
  ...rest
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  let customStyle = style

  switch (ideyaType) {
    case 'secondary':
      customStyle = { backgroundColor: themeStyle.btnBgRound, ...style }
      break
    case 'antd':
      customStyle = {
        backgroundColor: themeStyle.btnBgRound,
        color: themeStyle.colorText,
        border: `1px solid ${themeStyle.defaultBorderColor}`,
        ...style,
      }
      break
    default:
      customStyle = style
  }

  return <Button style={customStyle} {...rest} />
}
